import { AudioMention } from "@/types/Mention";
import { AudioMentionV4 } from "@/types/MentionCard";

/* getClosestMention
 * Finds the mention (past or future) that's closest to the given currentTime.
 *            current time
 *                 |
 *                 v
 * -------------|-------|--------------------|---|-----------------
 *              ^ this is closest mention
 */

function getClosestMention(
  mentions: AudioMention[] | AudioMentionV4[],
  currentTime: number
): AudioMention | AudioMentionV4 | null {
  let minDiff = Infinity;
  let closest: AudioMention | AudioMentionV4 | null = null;

  for (const obj of mentions) {
    const startDiff: number = Math.abs(currentTime - obj.context_start_timing);
    const endDiff: number = Math.abs(currentTime - obj.context_end_timing);

    const currentDiff: number = Math.min(startDiff, endDiff);

    if (currentDiff < minDiff) {
      minDiff = currentDiff;
      closest = obj;
    }
  }

  return closest;
}

export default getClosestMention;
